export default function replaceAll(sentence, wordsToReplace) {
    return Object.keys(wordsToReplace).reduce(
        (f, s, i) =>
            `${f}`.replace(new RegExp(s, 'ig'), wordsToReplace[s]),
        sentence
    )
}